export enum ENCODING {
    UTF8 = 'utf8',
    WINDOWS1251 = 'windows1251',
}

export const ENCODING_OPTIONS = [
    {
        id: ENCODING.UTF8,
        name: 'utf8',
    },
    {
        id: ENCODING.WINDOWS1251,
        name: 'windows1251',
    },
]

export enum TEMPLATE_FILES_TYPES {
    SELECT_FROM_FILE = 'selectFromFile',
    IPTV = 'ipTv',
    COURSES_CATALOG = 'coursesCatalog',
    CLASSROOMS_CATALOG = 'classroomsCatalog',
    GRADES_CATALOG = 'gradesCatalog',
    TEACHERS_CATALOG = 'teachersCatalog',
    SUBJECTS_CATALOG = 'subjectsCatalog',
    WINE_CATALOG = 'wineCatalog',
    MENU_PRODUCT_CATALOG = 'menuProductCatalog',
    COMMON_FAVOURITE_LINKS_CATALOG = 'commonFavouriteLinksCatalog',
    SCHOOL_SCHEDULE = 'schoolSchedule',
}
